'use client';

import { useHttpClient } from '@wix/fe-essentials-standalone';

import { useWixInstanceContext } from '@/components/Contexts/WixInstanceContext';

export function useApiClient() {
  const httpClient = useHttpClient();
  const instance = useWixInstanceContext();
  const authHeaders = { Authorization: instance ?? '' };

  return {
    get: <T>(url: string) => httpClient.get<T>(url, { headers: authHeaders }),
    post: <T>(url: string, data?: unknown) =>
      httpClient.post<T>(url, data, { headers: authHeaders }),
  };
}
